import React, { Component } from 'react'
import s from './index.module.scss'
import { http } from '../../../common/request'
import { Input, Form, Radio, Button, message, Spin } from 'antd'
import i18next from 'i18next'

class DataPushSetting extends Component {
  webhook_form = React.createRef()
  mqtt_form = React.createRef()

  constructor(props) {
    super(props)
    this.state = {
      data_validate: {
        validateStatus: '',
        errorMsg: '',
      },
      event_validate: {
        validateStatus: '',
        errorMsg: '',
      },
      disable: true,
      requesting: false,
      type: 'webhook',
      method: 'post',
      action: 'edit',
      webhook: {
        data: '',
        event: '',
      },
      mqtt: {
        mqtt_user_name: '',
        mqtt_user_secret: '',
        mqtt_broker_list: '',
        mqtt_client_pre: '',
        topic_data: '',
        topic_event: '',
      },
    }
  }

  componentDidMount() {
    this.getNewSetting()
  }

  //获取最新setting
  async getNewSetting() {
    this.setState({
      requesting: true,
    })
    const res = await http('get', '/account/settings').catch((err) => {
      this.setState({
        requesting: false,
      })
    })
    if (res.data && res.data.code === 0) {
      // console.log(res.data.data.callback, 'res.data.data')
      if (res.data.data.callback === undefined) {
        this.setState({
          requesting: false,
          mqtt: {
            mqtt_user_name: '',
            mqtt_user_secret: '',
            mqtt_broker_list: '',
            mqtt_client_pre: '',
            topic_data: '',
            topic_event: '',
          },
          webhook: {
            data: '',
            event: '',
          },
          disable: true,
        })

        if (this.state.type === 'webhook') {
          this.webhook_form.current.setFieldsValue({
            data: '',
            event: '',
          })
        } else {
          this.mqtt_form.current.setFieldsValue({
            mqtt_user_name: '',
            mqtt_user_secret: '',
            mqtt_broker_list: '',
            mqtt_client_pre: '',
            topic_data: '',
            topic_event: '',
          })
        }

        return
      }
      const type = res.data.data.callback.type
      this.setState({
        type,
        requesting: false,
        disable: true,
      })
      // console.log(this.state.type, 'type in getNewSetting')
      const values = res.data.data.callback.values
      if (type === 'webhook') {
        this.setState({
          webhook: {
            data: values.data && values.data.webhook && values.data.webhook,
            event: values.event && values.event.webhook && values.event.webhook,
          },
        })

        values.data &&
          values.data.webhook &&
          this.webhook_form.current.setFieldsValue({
            data: values.data.webhook,
          })

        values.event &&
          values.event.webhook &&
          this.webhook_form.current.setFieldsValue({
            event: values.event.webhook,
          })
      } else if (type === 'mqtt') {
        this.setState({
          mqtt: {
            mqtt_user_name: values.mqtt_user_name,
            mqtt_user_secret: values.mqtt_user_secret,
            mqtt_broker_list: values.mqtt_broker_list,
            mqtt_client_pre: values.mqtt_client_pre,
            topic_data: values.topic_data,
            topic_event: values.topic_event,
          },
        })
        this.mqtt_form.current.setFieldsValue({
          mqtt_user_name: values.mqtt_user_name,
          mqtt_user_secret: values.mqtt_user_secret,
          mqtt_broker_list: values.mqtt_broker_list,
          mqtt_client_pre: values.mqtt_client_pre,
          topic_data: values.topic_data,
          topic_event: values.topic_event,
        })
      }
    } else {
      this.setState({
        requesting: false,
      })
      message.warn(res.data.desc)
    }
  }

  test = () => {
    if (this.state.type === 'mqtt') {
      this.testMqtt()
    } else {
      this.testWebhook()
    }
  }
  testMqtt = () => {
    const values = this.mqtt_form.current.getFieldValue()
    const {
      mqtt_user_name,
      mqtt_user_secret,
      mqtt_broker_list,
      mqtt_client_pre,
      topic_data,
      topic_event,
    } = values
    this._test('mqtt', {
      mqttConfig: {
        username: mqtt_user_name,
        password: mqtt_user_secret,
        endpoint: mqtt_broker_list,
        clientId: mqtt_client_pre,
        topicData: topic_data,
        topicEvent: topic_event,
      },
    })
  }

  testWebhook = () => {
    const { data, event } = this.webhook_form.current.getFieldValue()
    this._test('http', {
      httpConfig: {
        urlData: data,
        urlEvent: event,
      },
    })
  }
  _test = (type, config) => {
    this.setState({
      testLoading: true,
    })
    http('post', '/v1/webapi/push/setting/check', {
      type,
      ...config,
    })
      .then((res) => {
        if (res?.data?.msg) {
          message.success(res.data.msg)
        } else {
          message.warn(JSON.stringify(res.data))
        }
      })
      .catch((error) => {
        if (error?.response?.data?.msg) {
          message.warn(error.response.data.msg)
        } else {
          message.warn(JSON.stringify(error.response.data))
        }
      })
      .finally(() => {
        this.setState({
          testLoading: false,
        })
      })
  }

  //回调管理
  async updateCallbackSettings(values) {
    this.setState({
      requesting: true,
    })
    const { type, method, action } = this.state
    // console.log(values, 'values of updateCallbackSettings')
    let params = {
      type: type,
      action,
    }

    if (type === 'webhook') {
      const { data, event } = values

      params.method = method
      params.tag = 'data'
      params.webhook = data

      if (data === '' && event === '') {
        params.action = 'delete'
      }

      // console.log(params, 'params1 of updateCallbackSettings')
      const res = await http(
        'get',
        '/app/updateCallbackSettings',
        params
      ).catch((err) => message.warn('设置失败'))
      if (res.data && res.data.code === 0) {
        // console.log(res.data.data, 'res.data.data')
        params.tag = 'event'
        params.webhook = event
        // console.log(params, 'params of webhook')
        if ((event === '' || event === undefined) && params.action === 'edit') {
          message.success('设置成功')
          this.getNewSetting()
          this.setState({
            requesting: false,
          })
          return
        }
        const res1 = await http(
          'get',
          '/app/updateCallbackSettings',
          params
        ).catch((err1) => {
          message.warn('设置失败')
          this.setState({
            requesting: false,
          })
        })

        if (res1.data && res1.data.code === 0) {
          message.success('设置成功')
          this.getNewSetting()
          this.setState({
            requesting: false,
          })
        } else {
          this.setState({
            requesting: false,
          })
          message.warn(res.data.desc)
        }
      } else {
        this.setState({
          requesting: false,
        })
        message.warn(res.data.desc)
      }
    } else if (type === 'mqtt') {
      console.log('112222')
      const {
        mqtt_user_name,
        mqtt_user_secret,
        mqtt_broker_list,
        mqtt_client_pre,
        topic_data,
        topic_event,
      } = values

      // console.log(mqtt_user_name === undefined, 'values of mqtt')
      if (
        mqtt_user_name === undefined &&
        mqtt_user_secret === undefined &&
        mqtt_broker_list === undefined &&
        mqtt_client_pre === undefined &&
        topic_data === undefined &&
        topic_event === undefined
      ) {
        params.action = 'delete'
      }

      params.mqtt_user_name = mqtt_user_name || ''
      params.mqtt_user_secret = mqtt_user_secret || ''
      params.mqtt_broker_list = mqtt_broker_list || ''
      params.mqtt_client_pre = mqtt_client_pre || ''
      params.topic_data = topic_data || ''
      params.topic_event = topic_event || ''

      try {
        const res = await http(
          'post',
          '/app/updateCallbackSettings',
          params
        ).catch((err) => {
          message.warn('系统错误')
          this.setState({
            requesting: false,
          })
        })

        if (res.data && res.data.code === 0) {
          message.success('设置成功')
          this.getNewSetting()
          this.setState({
            requesting: false,
          })
        }
      } catch (e) {
        console.log('request failed:', e)
      }
    }
  }

  clear() {
    const { type } = this.state
    // console.log(this.webhook_form, 'webhook_form')
    if (type === 'webhook') {
      this.webhook_form.current.resetFields(['data', 'event'])
      this.webhook_form.current.setFieldsValue({
        data: '',
        event: '',
      })
    } else {
      this.mqtt_form.current.resetFields()
      this.mqtt_form.current.setFieldsValue({
        mqtt_user_name: '',
        mqtt_user_secret: '',
        mqtt_broker_list: '',
        mqtt_client_pre: '',
        topic_data: '',
        topic_event: '',
      })
    }
  }

  onUrlChange(type) {
    // console.log(this.webhook_form.current.getFieldValue(type), 'webhook_form in onUrlChange')
    const value = this.webhook_form.current.getFieldValue(type)
    if (value === '' || value === undefined) {
      this.webhook_form.current.resetFields([type])
    }
    if (value && value.indexOf('http') > -1) {
      if (type === 'data') {
        this.setState({
          data_validate: {
            validateStatus: 'success',
            errorMsg: '',
          },
        })
      } else {
        this.setState({
          event_validate: {
            validateStatus: 'success',
            errorMsg: '',
          },
        })
      }
    } else {
      if (type === 'data') {
        this.setState({
          data_validate: {
            validateStatus: 'error',
            errorMsg: '请输入http或者https协议的接收地址',
          },
        })
      } else {
        this.setState({
          event_validate: {
            validateStatus: 'error',
            errorMsg: '请输入http或者https协议的接收地址',
          },
        })
      }
    }
  }

  render() {
    const {
      type,
      webhook,
      mqtt,
      requesting,
      disable,
      data_validate,
      event_validate,
    } = this.state
    // console.log(type, webhook, mqtt, 'type webhook mqtt')
    return (
      <div>
        {requesting ? (
          <Spin />
        ) : (
          <div>
            <div className={s.title}>{i18next.t('data_push_setting')}</div>

            <Radio.Group
              defaultValue="webhook"
              value={type}
              buttonStyle="solid"
              onChange={(e) => {
                console.log(e, 'value of change')
                this.setState({
                  type: e.target.value,
                  disable: true,
                })
              }}
            >
              <Radio.Button value="webhook">
                {i18next.t('webhook_setting')}
              </Radio.Button>
              <Radio.Button value="mqtt">
                {i18next.t('MQTT_setting')}
              </Radio.Button>
            </Radio.Group>

            {type === 'webhook' ? (
              <Form
                ref={this.webhook_form}
                style={{ marginTop: 20, width: 500 }}
                name="webhook"
                onFinish={(values) => {
                  this.updateCallbackSettings(values)
                }}
                initialValues={webhook}
              >
                <div className={s.formTitle}>
                  {i18next.t('device_data_webhook')}
                </div>
                <div className={s.location}>
                  {i18next.t('address_optional')}
                </div>
                <Form.Item
                  name="data"
                  validateStatus={data_validate.validateStatus}
                  help={data_validate.errorMsg}
                >
                  <Input
                    disabled={disable}
                    onChange={() => {
                      this.onUrlChange('data')
                    }}
                  />
                </Form.Item>

                <div className={s.formTitle}>
                  {i18next.t('device_time_webhook')}
                </div>
                <div className={s.location}>
                  {i18next.t('address_optional')}
                </div>
                <Form.Item
                  name="event"
                  validateStatus={event_validate.validateStatus}
                  help={event_validate.errorMsg}
                >
                  <Input
                    disabled={disable}
                    onChange={() => {
                      this.onUrlChange('event')
                    }}
                  />
                </Form.Item>

                <Form.Item style={{ marginTop: 24 }}>
                  {disable ? (
                    <Button
                      style={{ marginRight: 30 }}
                      type="primary"
                      onClick={() => {
                        this.setState({ disable: false })
                      }}
                    >
                      {i18next.t('edit')}
                    </Button>
                  ) : null}
                  {disable ? null : (
                    <Button
                      style={{ marginRight: 30 }}
                      type="primary"
                      htmlType="submit"
                    >
                      {i18next.t('save')}
                    </Button>
                  )}
                  {disable ? null : (
                    <Button
                      style={{ marginRight: 30 }}
                      type="dashed"
                      onClick={() => {
                        this.clear()
                      }}
                    >
                      {i18next.t('clear')}
                    </Button>
                  )}
                  {this.renderTestButton()}
                </Form.Item>
              </Form>
            ) : (
              <Form
                ref={this.mqtt_form}
                style={{ marginTop: 20, width: 500 }}
                name="mqtt"
                onFinish={(values) => {
                  this.updateCallbackSettings(values)
                }}
                initialValues={mqtt}
              >
                <span>User Name</span>
                <Form.Item name="mqtt_user_name">
                  <Input disabled={disable} />
                </Form.Item>

                <span>User Secret</span>
                <Form.Item name="mqtt_user_secret">
                  <Input disabled={disable} />
                </Form.Item>

                <span>Broker List</span>
                <Form.Item name="mqtt_broker_list">
                  <Input disabled={disable} />
                </Form.Item>

                <span>Client {i18next.t('before')}</span>
                <Form.Item name="mqtt_client_pre">
                  <Input disabled={disable} />
                </Form.Item>

                <span>{i18next.t('data')} Topic </span>
                <Form.Item name="topic_data">
                  <Input disabled={disable} />
                </Form.Item>

                <span>{i18next.t('event')} Topic </span>
                <Form.Item name="topic_event">
                  <Input disabled={disable} />
                </Form.Item>

                <Form.Item style={{ marginTop: 25 }}>
                  {disable ? (
                    <Button
                      style={{ marginRight: 30 }}
                      type="primary"
                      onClick={() => {
                        this.setState({ disable: false })
                      }}
                    >
                      {i18next.t('edit')}
                    </Button>
                  ) : null}
                  {disable ? null : (
                    <Button
                      style={{ marginRight: 30 }}
                      type="primary"
                      htmlType="submit"
                    >
                      {i18next.t('save')}
                    </Button>
                  )}
                  {disable ? null : (
                    <Button
                      style={{ marginRight: 30 }}
                      type="dashed"
                      onClick={() => {
                        this.clear()
                      }}
                    >
                      {i18next.t('clear')}
                    </Button>
                  )}
                  {this.renderTestButton()}
                </Form.Item>
              </Form>
            )}
          </div>
        )}
      </div>
    )
  }

  renderTestButton = () => (
    <Button loading={this.state.testLoading || false} onClick={this.test}>
      {i18next.t('test')}
    </Button>
  )
}

export default DataPushSetting
